import { BusinessRole } from '../../business/models/business-role';

export enum UserRole {
	SuperAdmin = 'super-admin',
	Admin = 'admin',
	Editor = 'editor',
	User = 'user',
	Guest = 'guest'
}

export const UserRoleMap: Readonly<Record<UserRole, number>> = {
	[UserRole.SuperAdmin]: 0,
	[UserRole.Admin]: 1,
	[UserRole.Editor]: 2,
	[UserRole.User]: 3,
	[UserRole.Guest]: 4
};

export function isUserRoleAtLeast(role: UserRole, target: UserRole): boolean {
	return UserRoleMap[role] <= UserRoleMap[target];
}

export interface BusinessRoleMembership {
	role?: BusinessRole;
	deactivated?: boolean;
	delete?: boolean;
	business?: {
		delete?: boolean;
	};
}

/**
 * Account notification preferences belong to site admins and users with at least
 * one active, non-Guest membership in a non-deleted business. External/approver-only
 * users must be managed through their BusinessUser Guest settings instead.
 */
export function canManageNotificationPreferences(role: UserRole | undefined, memberships: readonly BusinessRoleMembership[] = []): boolean {
	if (role && isUserRoleAtLeast(role, UserRole.Admin)) {
		return true;
	}

	return memberships.some(
		membership =>
			!!membership.role &&
			membership.role !== BusinessRole.Guest &&
			membership.deactivated !== true &&
			(membership.business?.delete === false || membership.delete === false)
	);
}
